const TODO_API_ROOT = '/ows/todo/api/v1';
const TODO_API_SETTINGS = '/settings';

export const TODO_API_GET_SETTINGS = TODO_API_ROOT + TODO_API_SETTINGS;
export const TODO_API_UPDATE_SETTING = TODO_API_ROOT + TODO_API_SETTINGS + '/{0}';
